import {object, string} from "yup";

const emptyFieldMsg = 'Поле не может быть пустым';

export const eventFormConfig = {
    method: 'POST',
    action: '/api/client/serviceregistration/client_register_session',
    initialValues: {
        last_name: '',
        first_name: '',
        email: '',
        phone: '',
        comment: ''
    },
    validationSchema: object().shape({
        // last_name: string().required(emptyFieldMsg),
        // first_name: string().required(emptyFieldMsg),
        // email: string().email('Некорректный e-mail').required(emptyFieldMsg),
        phone: string().required(emptyFieldMsg).matches(/^[+\d()-]+$/g, 'Некорректный телефон'),
        //eslint-disable-next-line
        comment: string().max(400, 'Максимально допустимое количество символов ${max}')
    })
};

export const eventFormFields = [
    {
        name: 'phone',
        fieldType: 'phone',
        label: 'Телефон'
    },
    {
        name: 'email',
        label: 'E-mail',
        disabled: true
    },
    {
        name: 'first_name',
        label: 'Имя',
        disabled: true
    },
    {
        name: 'last_name',
        label: 'Фамилия',
        disabled: true
    },
    {
        name: 'comment',
        fieldType: 'textarea',
        label: 'Комментарий'
    }
];